import { Outlet } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./Sidebar";

export default function TrainerLayout() {
  return (
    <div dir="ltr" style={styles.container}>
      <Header />

      <div style={styles.contentWrapper}>
        <Sidebar />

        <main style={styles.mainContent}>
          <Outlet />
        </main>
      </div>

      <style>{`
        @media (max-width: 768px) {
          .layout-responsive {
            flex-direction: column !important;
          }
          
          .sidebar-responsive {
            width: 100% !important;
            order: 2 !important;
          }
          
          .main-responsive {
            order: 1 !important;
          }
        }
      `}</style>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    background: '#f5f7fa',
  },
  contentWrapper: {
    display: 'flex',
    flex: 1,
    direction: 'rtl',
  },
  mainContent: {
    flex: 1,
    padding: '20px',
    background: '#fff',
    marginRight: '280px', // عرض السايدبار
    transition: 'margin-right 0.3s ease',
    minHeight: 'calc(100vh - 70px)', // ارتفاع الهيدر
    boxShadow: '0 0 20px rgba(0, 0, 0, 0.1) inset',
    borderRadius: '10px 0 0 0',
  },
};

// تعديل الـ margin عند طي السايدبار
const handleSidebarToggle = () => {
  if (typeof window !== 'undefined') {
    const style = document.createElement('style');
    style.textContent = `
      .sidebar-collapsed ~ main {
        margin-right: 80px !important;
      }
      
      @media (max-width: 768px) {
        .sidebar-collapsed ~ main,
        main {
          margin-right: 0 !important;
          margin-bottom: 60px !important;
        }
      }
    `;
    document.head.appendChild(style);
  }
};

// تعديل للجوال
const handleResponsiveLayout = () => {
  if (typeof window !== 'undefined') {
    const main = document.querySelector('[style*="mainContent"]');
    const sidebar = document.querySelector('[style*="sidebar"]');
    const container = document.querySelector('[style*="contentWrapper"]');
    
    if (window.innerWidth <= 768) {
      if (main) main.className = (main.className || '') + ' main-responsive';
      if (sidebar) sidebar.className = (sidebar.className || '') + ' sidebar-responsive';
      if (container) container.className = (container.className || '') + ' layout-responsive';
    }
  }
};

// إضافة تأثيرات عند التحميل
if (typeof window !== 'undefined') {
  setTimeout(() => {
    handleSidebarToggle();
    handleResponsiveLayout();
    
    window.addEventListener('resize', handleResponsiveLayout);
    
    // مراقبة تغييرات السايدبار
    const observer = new MutationObserver(() => {
      handleSidebarToggle();
    });
    
    const sidebar = document.querySelector('[style*="sidebar"]');
    if (sidebar) {
      observer.observe(sidebar, { attributes: true, attributeFilter: ['style'] });
    }
  }, 100);
}